/**
 * @author Karthik <karthik.x@314ecorp.com>
 * @description config
 */

import integrationConfig from './integration.config';
import productionConfig from './production.config';

export default ENVIRONMENT === 'production' ? productionConfig : integrationConfig;
